// NOTE: バックエンドの検索条件と処理を一致させる必要がある
export function searchQueryAnalyzer(query) {
  const and_operator = ' '

  // \s 空白文字 [ \t\r\n\f\v] 連続していた場合そのままsplitすると余分なqueryが生まれるので一つにまとめる
  return query.replace('　', and_operator).replace(/\s+/, and_operator).split(and_operator)
}
